import styled from 'styled-components';

export const StyledProjectInformation = styled.div`
  .project-info {
    margin-top: 20px;
    width: 100%;
    display: flex;

    form {
      width: 100%;
    }

    &-header {
      height: 40px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      margin-bottom: 20px;

      &-title {
        color: #2f2f35;
        font-family: Poppins;
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        align-content: center;
      }
    }

    &-period {
      .required {
        top: -3px;
      }
      input.datepicker {
        padding-left: 22px;
      }
      input:disabled {
        background-color: rgb(248, 248, 248);
        color: #999;
      }
    }

    &-body {
      width: inherit;

      &-group {
        display: flex;
        color: #2f2f35;
        font-family: Poppins;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        margin-bottom: 16px;

        > div {
          display: flex;
          align-items: center;
          margin-right: 16px;

          > span {
            width: 112px;
            height: 21px;
          }

          .MuiOutlinedInput-root.Mui-disabled {
            color: #585959;
          }

          .MuiOutlinedInput-root .MuiOutlinedInput-input:disabled {
            -webkit-text-fill-color: #585959;
          }

          > * {
            margin: 0px 5px;
            display: flex;
            align-items: center;
            white-space: nowrap;
          }
        }

        .project-info-no {
          > div {
            width: 298px;
          }
        }

        .project-info-name {
          > div {
            width: 304px;
          }
        }

        .project-info-period {
          > div {
            width: 298px;

            .datePickerWrapper {
              .react-datepicker-wrapper {
                .react-datepicker__input-container {
                  .datepicker {
                    padding-left: 11px;
                  }
                }
              }
            }
          }
        }

        .project-info-address {
          > div {
            width: 750px;
          }
        }

        .project-info-progress {
          position: relative;
          width: 100%;

          .MuiBox-root {
            .MuiLinearProgress-root {
              .MuiLinearProgress-bar {
                border-radius: 6px;
              }
            }
          }
        }
      }
    }
  }

  .project-view {
    margin: 20px 0px;
    padding-top: 20px;
    width: 100%;
    border-top: 1px solid #dadada;

    &-header {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      height: 40px;

      &-title {
        color: #2f2f35;
        font-family: Poppins;
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        align-content: center;
      }

      &-body {
        display: flex;
        flex-direction: row;
        gap: 6px;
      }
    }

    &-content {
      width: inherit;
      background-color: gray;
      margin: 18px 0px;
      height: 682px;

      &.empty {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 582px;
        background: #f8f8f8;
      }

      > div {
        .swiper {
          position: relative;

          .swiper-wrapper {
            .swiper-slide {
              .MuiPaper-root {
                background: #00000057;
              }
            }
          }

          .swiper-button-next,
          .swiper-button-prev {
            &::after {
              color: #ffffff;
            }
          }

          .swiper-pagination {
            position: absolute;
            width: 100%;
            left: 50%;
            bottom: 20px;
            transform: translateX(-50%);
            z-index: 1;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 8px;
          }

          .swiper-pagination-bullet {
            display: inline-block;
            width: 10px;
            height: 10px;
            background: #ffffff99;
            border-radius: 50%;
            opacity: 0.7;
            transition: all 0.3s;

            &:hover {
              opacity: 0.9;
            }
          }

          .swiper-pagination-bullet-active {
            background: #b38b3a;
            opacity: 1;
          }
        }
      }
    }

    &-button-group {
      display: flex;
      justify-content: end;

      > * {
        margin-left: 12px;
      }
    }
  }
`;
